import { composeValidators } from 'CorePackage/MainModule/validators/composeValidators';
import { makeRequired } from 'CorePackage/MainModule/validators/isRequired';
import { FormErrors } from 'KnmPackage/MainModule/types/FormErrors';
import { getArrayError } from 'CorePackage/MainModule/common/getArrayError';

import { IKnmErknmFormObject } from '../interfaces/IKnmErknmFormObject';
import { REQUIRED_ERROR } from '../../../CorePackage/MainModule/constants/validationErrors';
import { NOT_IN_FIAS_TEXT } from '../../../CorePackage/MainModule/constants/notInFIASText';

export const getObjectsErknmValidate = (
  objectsErknm: IKnmErknmFormObject[] | undefined,
  isEditableInStatusCommentsExist: boolean | undefined,
  shouldValidationForGeneratedDecision?: boolean,
  isUse4123?: boolean,
  isUse223_4114?: boolean,
  isTypeCodePP?: boolean,
  isCurrentYear?: boolean,
  isLaterThanFieldsMarksSetting?: boolean,
  hazardClassApplies?: boolean,
  isImpossibilityOfPrevious?: boolean,
): FormErrors<IKnmErknmFormObject>[] | undefined | string[] => {
  if ((shouldValidationForGeneratedDecision || isImpossibilityOfPrevious) && !objectsErknm?.length) {
    return getArrayError('Поле не может быть пустым');
  }

  return objectsErknm?.map(item => {
    return {
      name: item.ervkId ? makeRequired('Поле не может быть пустым')(item.name) : undefined,
      address: composeValidators(
        isUse4123 && item.isErrorFiasValue && !item.notInFIAS ? () => NOT_IN_FIAS_TEXT : () => undefined,
        item.notInFIAS ? () => undefined : makeRequired('Поле не может быть пустым'),
      )(item.address),
      objectType: makeRequired('Поле не может быть пустым')(item.objectType),
      objectKind: makeRequired('Поле не может быть пустым')(item.objectKind),
      objectSubKind: composeValidators(
        isEditableInStatusCommentsExist || isLaterThanFieldsMarksSetting
          ? makeRequired('Поле не может быть пустым')
          : () => undefined,
      )(item.objectSubKind),
      riskCategory: composeValidators(
        isEditableInStatusCommentsExist && !item.dangerClass
          ? makeRequired('Поле не может быть пустым')
          : () => undefined,
        isLaterThanFieldsMarksSetting && hazardClassApplies === false ? makeRequired(REQUIRED_ERROR) : () => undefined,
        !item.dangerClass &&
          item.riskCategory?.code !== '1' &&
          item.riskCategory?.code !== '2' &&
          isTypeCodePP &&
          isCurrentYear &&
          isUse223_4114
          ? () =>
              'Отсутствуют сведения о наличии высокой или чрезвычайно высокой категории риска для данного мероприятия'
          : () => undefined,
      )(item.riskCategory),
      dangerClass: composeValidators(
        isEditableInStatusCommentsExist && !item.riskCategory
          ? makeRequired('Поле не может быть пустым')
          : () => undefined,
        isLaterThanFieldsMarksSetting && hazardClassApplies ? makeRequired(REQUIRED_ERROR) : () => undefined,
      )(item.dangerClass),
      region:
        isUse4123 && item.notInFIAS && !item.ervkId
          ? makeRequired('Поле не может быть пустым')(item.region)
          : undefined,
      manualAddress:
        isUse4123 && item.notInFIAS ? makeRequired('Поле не может быть пустым')(item.manualAddress) : undefined,
    };
  });
};
